<template>
<div class="chapter">
<div class="inner_page">
<div class="fmtitle1"><span><a id="page7"></a><b>ACKNOWLEDGMENTS</b></span></div>
<div class="noindent"><span>I would like to acknowledge the following people who have brightened my path with their affection and support. Thank you for cheering as I walked boldly forward.</span></div>
<div class="indent"><span>Marie McGovern, for your friendship and all of your non-stop support, guidance, and encouragement while I found the right path. My friends Sue Hastings, Nancy Ritz, Mary Nale, Yaffa Copeland, Joel Wertz, Candie Michelle Toska, and Sally Brustowicz for sharing the laughter, tears, and joy through the years.</span></div>
<div class="indent"><span>Kelly Bowman, who loved my workshop and gave me the first opportunity to present it live at the Gift of Light Expo seven years ago! John Addison, of AVS Productions, who has included eleven of my workshops in his <i>Holistic Highway to Wisdom DVD Series</i>. My dearly departed friend, Ken Harsh, who was adamant in his belief that my workshop should be turned into a book.</span></div>
<div class="indent"><span>Paulina Cassidy, for your hauntingly beautiful music that brightened my energy while I transformed my workshop into a book format. Stevie Nicks, for your songs that I rocked out to whenever I felt blocked throughout the various times in my life.</span></div>
<div class="indent"><span>James Wanless, for including me in wonderful opportunities and for writing the foreword for my first book. Chris McClure, of Schiffer Publishing, for finding me at INATS and believing in me. Jerry Masek, for the professional photography session in the magical Cleveland Metroparks. My friend, Jill Mattson, for allowing me to use your beautiful artwork on my cover.</span></div>
<div class="indent"><span>Thank you to dear Claudius—my Spirit Guide and Past Life mate—for supporting, guiding, and encouraging me once more during this lifetime. Yes, you have been right every time, as you laughingly state to me.</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?54475924